import { defineAsyncComponent,  } from "vue";
import { createColumnInput, createColumnSelect } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";

import {
    createFieldCompanyAddress,
    createFieldCompanyAttachment,
    createFieldInfomation
} from "../company/company.section";
import { createUserField } from "../../../account/login/register.logic";
import { has } from "../../../../utils/menu-context";
import { callDepartment } from "../../master-mgt/department-responsible/department-responsible.logic";
import { callBusinessType } from "../company/company.logic";

const CardBorder = defineAsyncComponent(() => import('../../../../components/card/CardBorder'))
const TemplateBuilder = defineAsyncComponent(() => import('../../../../components/input/template-builder/TemplateBuilder'))

export const callRefApproveStatusType = ({ searchQuery }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'CONFIRM_STATUS', value: searchQuery })

export const createColumnsForNewRegister = ({ props }) => {
    let defaultCompanyDepartment = null
    if (!has({ menuContext: props?.menuContext, key: 'forCompany' })) {
        if (!has({ menuContext: props?.menuContext, key: 'canSearchByCompanyDepartment' })) {
            defaultCompanyDepartment =
                store.state.resource.auth.info?.user?.refDepartment?.refParent || store.state.resource.auth.info?.user?.refDepartment;
        }
    }
    const columns = [
        createColumnSelect({
            title: () => i18n.global.t("model.company.refBusinessType"),
            dataIndex: "refCompany.refBusinessType.value",
            customRender: ({ record }) => <div>{record.refCompany?.refBusinessType?.value}</div>,
            inputProp: () => ({ list: callBusinessType, optLabel: 'value' }),
            search: { name: "refCompany.refBusinessType.id" }
        }),
        createColumnInput({ title: () => i18n.global.t("model.company.nameTh"), dataIndex: "refCompany.nameTh" }),
        createColumnInput({ title: () => i18n.global.t("model.company.nameEn"), dataIndex: "refCompany.nameEn" }),
        createColumnSelect({
            title: () => i18n.global.t("model.company.refDepartment"),
            dataIndex: "refCompany.refDepartment.nameTh",
            customRender: ({ record }) => <div>{record.refCompany?.refDepartment?.nameTh}</div>,
            inputProp: () => ({ list: callDepartment, optLabel: 'nameTh' }),
            search: {
                name: "refCompany.refDepartment.id",
                visible: () => has({ menuContext: props?.menuContext, key: 'canSearchByCompanyDepartment' }),
                field: { searchValue: defaultCompanyDepartment }
            }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.company.refStatus"),
            dataIndex: "refApproveStatus.value",
            customRender: ({ record }) => <div>{record.refApproveStatus?.value}</div>,
            inputProp: () => ({ list: callRefApproveStatusType, optLabel: 'value' }),
            search: { name: "refApproveStatus.id" }
        }),
    ]
    return columns
}

export const createRulesForNewRegister = () => {
    return {}
}

export const createFieldForNewRegister = ({ props, data, isLoading }) => {
    data.section.companyUser = createUserField({ props, data })
    data.section.information = createFieldInfomation({ props, data, key: 'refCompany', isLoading })
    data.section.companyAddress = createFieldCompanyAddress({ props, data, key: 'refCompany', isLoading })
    data.section.companyAttachment = createFieldCompanyAttachment({ props, data, key: 'refCompany', isLoading })
    data.changeLogFields.push(...data.section.companyUser)
    data.changeLogFields.push(...data.section.information)
    data.changeLogFields.push(...data.section.companyAddress)
    data.changeLogFields.push(...data.section.companyAttachment)
    return [
        {
            visible: () => true,
            colProp: () => ({ xs: 24 }),
            formItemRender: () => <CardBorder title = {i18n.global.t('model.user.modelName')}>
                <TemplateBuilder
                    rowProp={data.rowProp}
                    useForm={data.useForm}
                    fields={data.section.companyUser}
                    skeleton={isLoading.value}
                ></TemplateBuilder>
            </CardBorder>,
        },
        {
            visible: () => true,
            colProp: () => ({ xs: 24 }),
            formItemRender: () => <CardBorder title={i18n.global.t('views.company.register.title')}>
                <TemplateBuilder
                    rowProp={data.rowProp}
                    useForm={data.useForm}
                    fields={data.section.information}
                    skeleton={isLoading.value}
                ></TemplateBuilder>
            </CardBorder>,
        },
        {
            visible: () => true,
            colProp: () => ({ xs: 24 }),
            formItemRender: () => <CardBorder title={i18n.global.t('views.company.address.title')}>
                <TemplateBuilder
                    rowProp={data.rowProp}
                    useForm={data.useForm}
                    fields={data.section.companyAddress}
                    skeleton={isLoading.value}
                ></TemplateBuilder>
            </CardBorder>,
        },
        {
            visible: () => true,
            colProp: () => ({ xs: 24 }),
            formItemRender: () => <CardBorder title={i18n.global.t('views.company.register.attachment.title')}>
                <TemplateBuilder
                    rowProp={data.rowProp}
                    useForm={data.useForm}
                    fields={data.section.companyAttachment}
                    skeleton={isLoading.value}
                ></TemplateBuilder>
            </CardBorder>,
        },
    ]
}
